/**
 * The one description of what a cover is, for everything that writes one: the card menus'
 * "Edit cover…" pickers, CoverImage's own drag-to-replace, and the create/edit forms.
 *
 * 640x380 because the grid cards render a cover in a 16/9 frame (ui-kit `Card`'s media), so a
 * square source would centre-crop and cut faces. It was previously spelled out at five separate
 * call sites, and one of them drifted to 340x340 and shipped that crop.
 */
export const COVER_SIZE = { width: 640, height: 380 };

/** Formats `formatPicture` can actually read. GIFs bypass it and are stored as uploaded. */
export const COVER_MIME_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'];

/** The same list in the comma-separated form a file input's `accept` wants. */
export const COVER_ACCEPT = COVER_MIME_TYPES.join(', ');
